import React from 'react';
import { Link } from 'react-router-dom';

export const Header: React.FC = () => {
  return (
    <header
      style={{
        borderBottom: 'var(--border-chunky)',
        backgroundColor: 'var(--color-bg)',
      }}
    >
      <div
        className="container flex justify-between items-center"
        style={{ padding: 'var(--space-4) var(--space-4)' }}
      >
        <Link
          to="/"
          aria-label="WebGen Engine - Home"
          style={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-3)',
          }}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              backgroundColor: 'var(--color-fg)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--color-bg)',
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: 'var(--text-xl)',
            }}
          >
            W
          </div>
          <span
            className="sm:hidden"
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: 'var(--text-xl)',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: 'var(--color-fg)',
            }}
          >
            WebGen Engine
          </span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
